var axios = require('axios');

var projectNo = "SFT";

var pageindex = 1;

var pagesize = 12;




export default {


  /*  TIANYAURL: "http://rjttj.softtone.cn", // 登录，用户管理

    APIURL: "http://api1.softtone.cn",

    USERURL: "http://share.jqweike.com/", // 有关用户信息的api

    RESOURCEURL: "http://api1.softtone.cn", //资源 */

  /* 	TIANYAURL:"http://122.225.6.194:8099", // 登录，用户管理

  	APIURL: "http://122.225.6.194:8082",

  	USERURL: "http://122.225.6.194:8091/", // 有关用户信息的api

  	RESOURCEURL: "http://122.225.6.194:8082", //资源 */

  	TIANYAURL:apiConfig.TIANYAURL, // 登录，用户管理

  	APIURL: apiConfig.APIURL,

  	USERURL: apiConfig.USERURL, // 有关用户信息的api

  	RESOURCEURL: apiConfig.RESOURCEURL, //资源

    getOrgID() {
      let orgUrl = "";
      if (localStorage.getItem("orgId") != null) {
        orgUrl = "&orgID=" + localStorage.getItem("orgId");
      }
      return orgUrl;
    },

    //获取机构的授权版本
    getOrgVersion:function(orgID){

      return axios.get(this.APIURL +"/softtone/getOrgVersion?orgID="+orgID)

    },
  //跟新数据
  UpdateUserData: function(userId, token) {
    var params = new URLSearchParams();

    return axios.post(this.TIANYAURL + "/user/thirdParty/get-and-save", {
      userID: userId,
      username: "",
      headerurl: "",
      token: token,
      projectCode: projectNo
    });
  },
  //游客登录
  TouristLogin: function() {
    return axios.post(this.TIANYAURL + "/user/guest?projectNo=" + projectNo, {

    })
  },

  //获取积分
  GetScore: function(token) {

    return axios.get(this.TIANYAURL + "/vip/score/getScoreGrade", {
      params: {
        projectNo: projectNo
      },
      headers: {
        "Authorization": token
      }
    })
  },

  //积分加入
  SetScore: function(type, token) {
    var url = this.TIANYAURL + "/vip/user/score/set?type=" + type + "&projectNo=" + projectNo
    return axios({
      method: "post",
      url: url,
      headers: {
        "Authorization": token,
        "Content-type": "application/x-www-form-urlencoded"
      }
    })
  },

  //学习记录
  StudyRecord: function(year, token) {
    return axios.get(this.TIANYAURL + "/log/getalllog", {
      params: {
        year: year,
        projectNo: projectNo
      },
      headers: {
        "Authorization": token
      }
    })
  },

  //判断当前机构是否有开通下载视频权限
  getdownloadLimit: function() {
    var orgId = localStorage.getItem("orgId");
    return axios.get(this.TIANYAURL + '/admin/switchVideo/get?institutionID=' + orgId, {})
  },
  // 获取最新课程
  GetNewlist: function() {
    let orgUrl = this.getOrgID();

    return axios.get(this.APIURL + "/Course/newest/get?count=4" + orgUrl, {})
  },
  // 获取热门课程
  GetHotlist: function() {
    let orgUrl = this.getOrgID();
    return axios.get(this.APIURL + "/Course/hot/get?count=4" + orgUrl, {})
  },

  //点击首页更多时使用
  // 获取最新课程
  GetNewlist1: function(pageIndex) {
    let orgUrl = this.getOrgID();
    return axios.get(this.APIURL + "/Course/new/get?pageIndex=" + pageIndex + "&pageSize=6" + orgUrl, {})
  },
  // 获取热门课程
  GetHotlist1: function(pageIndex) {
    let orgUrl = this.getOrgID();
    return axios.get(this.APIURL + "/Course/hot/list?pageindex=" + pageIndex + "&pagesize=4" + orgUrl, {})
  },

  // 获取快速导航分类
  CourseGetNav: function() {
    return axios.get(this.APIURL + "/category/get/nav/yd", {})
  },
  // 获取快速导航的软件
  CourseGetGroup: function(IDCode) {
    let orgUrl = this.getOrgID();
	return axios.get(this.APIURL + "/category/get/group/yd?IDCode="+IDCode+orgUrl, {})

  },
  
  // 通过分类IDCode和Level 获取下级分类，课程组，课程
  CourseByCateLevel: function(IDCode, levelID) {
    let orgUrl = this.getOrgID();
    return axios.get(this.APIURL + "/courseByCateLevel/get?IDCode=" + IDCode + "&levelID=" + levelID + orgUrl, {})
  },

  // 通过课程IDCode 获取课程 和章节列表，第一章第一节的章节ID
  GetCourse: function(IDCode, orgID) {
    let orgUrl = this.getOrgID();
    return axios.get(this.APIURL + "/Course/get?IDCode=" + IDCode + orgUrl, {})
  },

  // 根据章节获取视频
  GetByChapterID: function(firstChapterID) {
    return axios.get(this.APIURL + "/Resouce/getByChapterID?ID=" + firstChapterID +
      "&projectCode=SFT&hasCatalog=true", {})
  },

  // 通过课程组IDCode 获取课程
  CourseByGroup: function(IDCode, type, pageindex, pagesize) {
    let orgUrl = this.getOrgID();
    return axios.get(this.APIURL + "/courseByGroup/get?IDCode=" + IDCode + "&courseType=" + type +
      "&pageIndex=" + pageindex + "&pageSize=" + pagesize + orgUrl, {})
  },

  // 获取关联id1的所有问题
  getRelatedid: function(relatedid2, pageindex) {
    return axios.get(this.TIANYAURL + "/question/relatedid2/get?relatedid2=" + relatedid2 + "&projectNo=" +
      projectNo + "&pageIndex=" + pageindex + "&pageSize=10", {})
  },
  //根据问题ID获取所有答案
  getAnswer: function(questionId) {
    return axios.post(this.TIANYAURL + "/question/get/" + questionId + "?pageindex=1&pagesize=999", );
  },
  //添加问题
  AddQuestion: function(RelatedId1, RelatedId2, title, context) {
    var token = localStorage.getItem("accessToken");
    var url = this.TIANYAURL + "/question/add";
    console.log(RelatedId1 + "/" + RelatedId2 + "/" + title + "/" + context)
    return axios({
      method: "post",
      url: url,
      data: {
        "RelatedId1": RelatedId1,
        "RelatedId2": RelatedId2,
        "productNo": projectNo,
        "title": title,
        "context": context
      },
      headers: {
        "Authorization": token,
      }
    })
  },
  //回答问题
  AddAnswer: function(context, questionId) {
    var token = localStorage.getItem("accessToken");
    var userId = localStorage.getItem("userId");
    var url = this.TIANYAURL + "/question/answer/add";
    return axios({
      method: "post",
      url: url,
      data: {
        "questionId": questionId,
        "projectNo": projectNo,
        "context": context,
        "UserId": userId
      },
      headers: {
        "Authorization": token,
      }
    })
  },
  // 搜索课程
  SearchCourse: function(keyword) {
    let orgUrl = this.getOrgID();
    return axios.get(this.APIURL + "/Course/search?keyword=" + encodeURI(keyword)  +orgUrl)
  },

  // 根据分类编码和课程组编码搜索
  SearchByContion: function(keyword, groupid, pageindex, pageSize) {
    let orgUrl = this.getOrgID();
    return axios.get(this.APIURL + "/Course/searhByContion?keyword=" + keyword +
      "&groupIDCode=" + groupid + "&pageIndex=" + pageindex +
      "&pageSize=" + pageSize + orgUrl)
  },

  // 获取笔记列表
  getNoteList: function(videoID, column, pageindex) {
    var token = localStorage.getItem("accessToken");
    return axios.get(this.TIANYAURL + "/note/list?relatedId=" + videoID + "&column=" + column + "&projectNo=" +
      projectNo + "&pageIndex=" + pageindex + "&pageSize=10", {
        headers: {
          'Authorization': token,
        },
      })
  },

  // 根据当前课程，获取推荐的课程 根据课程找到对应的分类，再从分类中随机查找课程
  GetRecommend: function(count, IDCode) {
    let orgUrl = this.getOrgID();
    return axios.get(this.APIURL + "/Course/recommend/get?count=" + count + "&curCourseID=" + IDCode + orgUrl, {})
  },

  // 删除笔记
  DeleteNote: function(noteId) {
    var token = localStorage.getItem("accessToken");
    var url = this.TIANYAURL + "/note/delete/" + noteId;
    return axios({
      method: "post",
      url: url,
      headers: {
        "Authorization": token,
      }
    })
  },
  //添加笔记
  AddNote: function(title, context, CourseID, VideoID) {
    var token = localStorage.getItem("accessToken");
    var imageurl = localStorage.getItem("headImg");
    var url = this.TIANYAURL + "/note/add";
    return axios({
      method: "post",
      url: url,
      data: {
        "title": title,
        "context": context,
        "imageurl": imageurl,
        "screenShotTime": null,
        "relatedId1": CourseID,
        "relatedId2": VideoID,
        "projectNo": projectNo
      },
      headers: {
        "Authorization": token,
      }
    })
  },
  // 添加日志
  AddLog: function(videoId, videoName, logType) {
    var token = localStorage.getItem("accessToken");
    var userId = localStorage.getItem("userId");
    var url = this.TIANYAURL + "/log/add";
    var urlData = "";


    if (logType == "ReadCourse" || logType == "StoreCourse") {
      urlData = "/index/details/" + videoId;
    } else if (logType == "ReadVideo" || logType == "StoreVideo") {
      urlData = "/index/video/" + videoId;
      videoId = videoId.substring((videoId.indexOf("/") + 1), videoId.length)
    }


    return axios({
      method: "post",
      url: url,
      data: {
        "RelateID": videoId,
        "Title": videoName,
        "LogType": logType,
        "LastUpdate": this.getNowFormatDate(),
        "ProjectNo": "SFT",
        "IP": "",
        "Url": urlData,
        "IsTest": false,
      },
      headers: {
        "Authorization": token,
      }
    })
  },


  // 转换时间
  formatSeconds: function(a) {
    var hh = parseInt(a / 3600);
    if (hh < 10) hh = "0" + hh;
    var mm = parseInt((a - hh * 3600) / 60);
    if (mm < 10) mm = "0" + mm;
    var ss = parseInt((a - hh * 3600) % 60);
    if (ss < 10) ss = "0" + ss;
    var length = hh + ":" + mm + ":" + ss;
    if (a > 0) {
      return length;
    } else {
      return "00:00:00";
    }
  },
  //获取当前时间
  getNowFormatDate: function() {
    var date = new Date();
    var seperator1 = "-";
    var seperator2 = ":";
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate +
      " " + date.getHours() + seperator2 + date.getMinutes() +
      seperator2 + date.getSeconds();
    return currentdate;
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/api/api2.js
// module id = null
// module chunks = 